import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ra-backend-state-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './backend-state-information.component.html',
  styleUrls: ['./backend-state-information.component.scss'],
})
export class BackendStateInformationComponent {}
